class NewSiteController {
    constructor() {
        // Constructor should not use jQuery - it runs at import time
    }

    init() {
        // Initialize Bootstrap 5 native offcanvas
        const mainMenu = document.getElementById('main-menu');
        
        if (window.bootstrap && window.bootstrap.Offcanvas && mainMenu) {
            new window.bootstrap.Offcanvas(mainMenu, {
                placement: 'left',
                toggle: false
            });
        } else {
            // Retry if Bootstrap not yet loaded
            console.warn('Bootstrap Offcanvas not available yet, retrying...');
            setTimeout(() => {
                if (window.BC && window.BC.new_site) {
                    window.BC.new_site.init();
                }
            }, 100);
            return;
        }
    }


    initializeSwipers() {
        // Only initialize Swipers if we're on a page that needs them
        const needsSwiper = document.querySelector('.swiper-container, .swiper-featured-properties, .swiper-feedback, .swiper-container-homepage');
        
        if (!needsSwiper) {
            // No swiper elements on this page, skip initialization
            return;
        }
        
        console.log('Initializing Swipers...');
        
        // Check if Swiper is available
        if (!window.Swiper) {
            console.warn('Swiper is not available on this page. Skipping Swiper initialization.');
            return;
        }
        
        // Initialize featured properties swiper
        const featuredContainer = document.querySelector(".swiper-featured-properties");
        if (featuredContainer && !featuredContainer.swiper) {
            console.log('Initializing featured properties swiper');
            
            window.featuredSwiper = new window.Swiper(".swiper-featured-properties", {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: true,
                centeredSlides: false,
                grabCursor: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: '.swiper-button-next.featured-properties',
                    prevEl: '.swiper-button-prev.featured-properties'
                }
            });
        }
        
        // Initialize feedback swiper
        const feedbackContainer = document.querySelector(".swiper-feedback");
        
        if (feedbackContainer && !feedbackContainer.swiper) {
            try {
                window.feedbackSwiper = new window.Swiper(".swiper-feedback", {
                    slidesPerView: 1,
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    navigation: {
                        nextEl: '.swiper-button-next.feedback',
                        prevEl: '.swiper-button-prev.feedback'
                    }
                });
                
            } catch (error) {
                console.error('Error initializing feedback swiper:', error);
            }
        }
    }
    
    show() {
        console.log('NewSite show() method called');
        
        // Initialize Swipers first
        this.initializeSwipers();
        
        // Handle featured property link clicks
        document.querySelectorAll(".featured-property-link").forEach(link => {
            link.addEventListener('click', function() {
                const featuredProperty = document.getElementById('featured-property');
                if (featuredProperty) {
                    if (window.bootstrap && window.bootstrap.Collapse) {
                        new window.bootstrap.Collapse(featuredProperty).show();
                    }
                }
            });
        });

        // Handle blog article link clicks  
        document.querySelectorAll(".blog-article-link").forEach(link => {
            link.addEventListener('click', function() {
                const blogArticle = document.getElementById('blog-article');
                if (blogArticle) {
                    if (window.bootstrap && window.bootstrap.Collapse) {
                        new window.bootstrap.Collapse(blogArticle).show();
                    }
                }
            });
        });

        // Handle "more why ben" button clicks
        document.querySelectorAll(".moreWhyBenButton").forEach(button => {
            button.addEventListener('click', function() {
                const whyBenSection = document.getElementById("why-ben");
                if (whyBenSection) {
                    // Hide ellipsis elements
                    whyBenSection.querySelectorAll(".ellipsis").forEach(element => {
                        element.style.visibility = "hidden";
                    });
                    
                    // Show more elements
                    whyBenSection.querySelectorAll(".more").forEach(element => {
                        element.style.visibility = "visible";
                    });
                    
                    // Hide more buttons
                    whyBenSection.querySelectorAll(".moreWhyBenButton").forEach(element => {
                        element.style.display = "none";
                    });
                    
                    // Increase height
                    const currentHeight = whyBenSection.offsetHeight;
                    whyBenSection.style.height = (currentHeight + 220) + "px";
                }
            });
        });

        // Handle navigation link clicks (hide offcanvas menu)
        document.querySelectorAll(".nav-link").forEach(link => {
            link.addEventListener('click', function() {
                const mainMenu = document.getElementById('main-menu');
                if (mainMenu) {
                    if (window.bootstrap && window.bootstrap.Offcanvas) {
                        const offcanvasInstance = window.bootstrap.Offcanvas.getInstance(mainMenu);
                        if (offcanvasInstance) offcanvasInstance.hide();
                    }
                }
            });
        });

        // Handle escape key to close menus
        document.addEventListener('keydown', function(e) {
            if (e.keyCode === 27) {
                const mainMenu = document.getElementById('main-menu');
                const featuredProperty = document.getElementById('featured-property');
                const blogArticle = document.getElementById('blog-article');
                
                // Hide offcanvas menu
                if (mainMenu) {
                    if (window.bootstrap && window.bootstrap.Offcanvas) {
                        const offcanvasInstance = window.bootstrap.Offcanvas.getInstance(mainMenu);
                        if (offcanvasInstance) offcanvasInstance.hide();
                    }
                }
                
                // Hide collapse elements
                if (featuredProperty) {
                    if (window.bootstrap && window.bootstrap.Collapse) {
                        const collapseInstance = window.bootstrap.Collapse.getInstance(featuredProperty);
                        if (collapseInstance) collapseInstance.hide();
                    }
                }
                
                if (blogArticle) {
                    if (window.bootstrap && window.bootstrap.Collapse) {
                        const collapseInstance = window.bootstrap.Collapse.getInstance(blogArticle);
                        if (collapseInstance) collapseInstance.hide();
                    }
                }
            }
        });

        // Handle contact info hover (replace with mouseenter/mouseleave)
        const contactInfo = document.getElementById('contact-info');
        const contactModal = document.getElementById('contactModal');
        if (contactInfo && contactModal) {
            contactInfo.addEventListener('mouseenter', () => {
                this.fadeToggleModal(contactModal);
            });
            contactInfo.addEventListener('mouseleave', () => {
                this.fadeToggleModal(contactModal);
            });
        }

        // Handle login modal click (prevent propagation)
        const loginModal = document.getElementById('loginModal');
        if (loginModal) {
            loginModal.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }

        // Handle body click to close login modal
        document.body.addEventListener('click', () => {
            if (loginModal && loginModal.offsetParent !== null) { // Check if visible
                this.fadeToggleModal(loginModal);
            }
        });


        // Initialize blog swiper with modern syntax
        if (document.querySelector(".swiper-container-homepage.blog")) {
            let blogSwiper = new window.Swiper(".swiper-container-homepage.blog", {
                slidesPerView: "auto",
                centeredSlides: true,
                initialSlide: 0,
                loop: true,
                spaceBetween: 30,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: '.swiper-button-next.blog',
                    prevEl: '.swiper-button-prev.blog'
                },
                on: {
                    init: function() {
                        console.log('Blog swiper initialized');
                    }
                }
            });
        }

        // Initialize mobile blog swiper with modern syntax
        if (document.querySelector(".swiper-container-homepage.blog-mobile")) {
            let blogSwiperMobile = new window.Swiper(".swiper-container-homepage.blog-mobile", {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: '.swiper-button-next.blog-mobile',
                    prevEl: '.swiper-button-prev.blog-mobile'
                },
                on: {
                    init: function() {
                        console.log('Mobile blog swiper initialized');
                    }
                }
            });
        }

        // Initialize mortgage widget on DOM content loaded
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                getMortgageWidgetValues();
                setStyledMortgageWidgetValues();
                updateFlashAlert();
            });
        } else {
            // DOM is already loaded
            getMortgageWidgetValues();
            setStyledMortgageWidgetValues();
            updateFlashAlert();
        }

        // Handle mortgage widget slider events
        const purchasePriceSlider = document.getElementById("purchase-price");
        if (purchasePriceSlider) {
            purchasePriceSlider.addEventListener("input", function() {
                getMortgageWidgetValues();
                setStyledMortgageWidgetValues();
            });
        }

        const loanPctSlider = document.getElementById("loan-pct");
        if (loanPctSlider) {
            loanPctSlider.addEventListener("input", function() {
                getMortgageWidgetValues();
                setStyledMortgageWidgetValues();
            });
        }

        const interestRateSlider = document.getElementById("interest-rate");
        if (interestRateSlider) {
            interestRateSlider.addEventListener("input", function() {
                getMortgageWidgetValues();
                setStyledMortgageWidgetValues();
            });
        }

        const mortgageSaveButton = document.getElementById("mortgage-save-button");
        if (mortgageSaveButton) {
            mortgageSaveButton.addEventListener("click", function() {
                getMortgageWidgetValues();
                
                // Replace jQuery AJAX with fetch API
                fetch("/investments", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
                    },
                    body: JSON.stringify({
                        investment: {
                            purchase_price: purchase_price,
                            loan1_pct: loan_pct,
                            loan1_interest_rate: interest_rate
                        },
                        commit: "Save",
                        from_widget: "True"
                    })
                })
                .then(response => {
                    if (response.ok) {
                        console.log("successful");
                        window.location.href = "my-properties";
                    } else {
                        throw new Error('Network response was not ok');
                    }
                })
                .catch(error => {
                    console.log("error", error);
                    window.location.href = "signin";
                });
            });
        }
    }

    // Helper function to toggle modal with fade effect
    fadeToggleModal(modal) {
        if (!modal) return;
        
        if (modal.offsetParent === null) { // Currently hidden
            modal.style.display = 'block';
            modal.style.opacity = '0';
            modal.style.transition = 'opacity 0.3s ease';
            // Force reflow
            modal.offsetHeight;
            modal.style.opacity = '1';
        } else { // Currently visible
            modal.style.transition = 'opacity 0.3s ease';
            modal.style.opacity = '0';
            setTimeout(() => {
                modal.style.display = 'none';
            }, 300);
        }
    }
}

window.BC = window.BC || {};
window.BC.new_site = new NewSiteController();

// Global variables for mortgage widget
let purchase_price = 0;
let loan_pct = 0;
let interest_rate = 0;
let mortgage_amount = 0;
let annual_taxes = 0;
let annual_insurance = 0;
let mortgage_period = 0;
let monthly_mortgage_cost = 0;

function getMortgageWidgetValues() {
    const purchasePriceElement = document.getElementById('purchase-price');
    const loanPctElement = document.getElementById('loan-pct');
    const interestRateElement = document.getElementById('interest-rate');
    
    purchase_price = purchasePriceElement ? purchasePriceElement.value : 0;
    loan_pct = loanPctElement ? loanPctElement.value : 0;
    interest_rate = interestRateElement ? interestRateElement.value : 0;
    mortgage_amount = purchase_price * (loan_pct / 100);
    annual_taxes = 1000;
    annual_insurance = 1000;
    mortgage_period = 30;
    calculateMortgageWidgetMonthlyCost();
}

function calculateMortgageWidgetMonthlyCost() {
    let mortgage = new window.BC.Mortgage.Fixed({
        years: mortgage_period,
        price: mortgage_amount,
        interest_percent: interest_rate,
        annual_taxes: annual_taxes,
        annual_insurance: annual_insurance
    });
    monthly_mortgage_cost = Math.round(mortgage.monthly_payment());
}

function setStyledMortgageWidgetValues() {
    const purchasePriceLabel = document.getElementById('purchase-price-label');
    const loanPctLabel = document.getElementById('loan-pct-label');
    const interestRateLabel = document.getElementById('interest-rate-label');
    const monthlyPayment = document.getElementById('monthly-payment');
    
    if (purchasePriceLabel) {
        purchasePriceLabel.textContent = NumberHelpers.number_to_currency(purchase_price, {precision: 0});
    }
    if (loanPctLabel) {
        loanPctLabel.textContent = NumberHelpers.number_to_percentage(loan_pct, {precision: 0});
    }
    if (interestRateLabel) {
        interestRateLabel.textContent = NumberHelpers.number_to_percentage(interest_rate, {precision: 3});
    }
    if (monthlyPayment) {
        monthlyPayment.textContent = NumberHelpers.number_to_currency(monthly_mortgage_cost, {precision: 0});
    }
}

function updateFlashAlert() {
    // Update mobile homepage when there is a flash alert
    const mobileHomeFlash = document.getElementById('mobileHomeFlash');
    if (mobileHomeFlash && mobileHomeFlash.offsetParent !== null) { // Check if visible
        // Reformat mobile homepage logo margin if there is a flash message
        const mobileHomeLogo = document.getElementById('mobileHomeLogo');
        if (mobileHomeLogo) {
            mobileHomeLogo.style.marginTop = '20px';
        }
        
        // Hide flash notification with CSS transition
        setTimeout(function() {
            mobileHomeFlash.style.transition = 'opacity 3s ease';
            mobileHomeFlash.style.opacity = '0';
        }, 3000);
    }
}